module.exports = __webpack_public_path__ + "img/wg-perki.2e90a23c.png";